import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import CorporatePage from './pages/CorporatePage';
import ServicesPage from './pages/ServicesPage';
import CountriesPage from './pages/CountriesPage';
import ContactPage from './pages/ContactPage';
import './App.css';

// Router içinde kullanılacak içerik bileşeni
function AppContent() {
  const location = useLocation();
  
  // Sayfa değiştiğinde en üste kaydır (hash link hariç)
  React.useEffect(() => {
    // URL'de hash yoksa en üste kaydır
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="app">
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/kurumsal" element={<CorporatePage />} />
          <Route path="/hizmetlerimiz" element={<ServicesPage />} />
          <Route path="/ulkeler" element={<CountriesPage />} />
          <Route path="/iletisim" element={<ContactPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

// Ana App bileşeni
function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;